
export default {
  name: 'DeleteConfirm',

  props: {
    data: {
      type: Array,
      required: true
    }
  }
};
